import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5 5.5L5.8828 19.6248C5.94868 20.6788 6.82278 21.5 7.8789 21.5H16.1211C17.1772 21.5 18.0513 20.6788 18.1172 19.6248L19 5.5M5 5.5H3M5 5.5H8.5M19 5.5H21M19 5.5H15.5M8.5 5.5V3.5C8.5 2.94772 8.94772 2.5 9.5 2.5H14.5C15.0523 2.5 15.5 2.94772 15.5 3.5V5.5M8.5 5.5H15.5M9.5 8.5V17.5M14.5 8.5V17.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
